import { cn } from "@traqly/ui/lib/utils";

interface IErrorMessageProps {
  className?: string;
  text?: string;
}

export function ErrorMessage(props: IErrorMessageProps) {
  return (
    <p
      className={cn("text-error-700! text-body-medium-medium", props.className)}
    >
      {props.text}
    </p>
  );
}
